import { FeedItem } from '@knocklabs/client';

/**
 * Reads Knock template `action_url` block as plain URL text.
 */
export function getNotificationItemActionUrlBlock(item: FeedItem): string | null {
  const block = item.blocks?.find((entry) => entry.name === 'action_url');
  if (!block || !('rendered' in block) || typeof block.rendered !== 'string') {
    return null;
  }

  const url = block.rendered.replace(/<[^>]+>/g, '').trim();
  return url || null;
}
